// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"SideBar_sidebarWrapper__4ot83","collapseSidebarWrapper":"SideBar_collapseSidebarWrapper__0TLuR"};